import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAmAtm3kPyWo2QbQ6mNPxWMqGfohuiXT5E",
  authDomain: "lijeul.firebaseapp.com",
  projectId: "lijeul",
  storageBucket: "lijeul.firebasestorage.app",
  messagingSenderId: "1079560321914",
  appId: "1:1079560321914:web:bb15672710862f40a334c3",
  measurementId: "G-6W68GFJM81",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
